// Stability Maintenance Routes
import { lazy } from 'react'
import { createRoute } from '@/helpers/createRoute'

import StabilityMaintenanceModules from '@/pages/StabilityMaintenanceModules'
import PackagingManager from '../PackagingManager'

const Analyst = lazy(() => import('@/modules/stability-maintenance-module/Analyst'))
const Abbreviation = lazy(() => import('@/modules/stability-maintenance-module/Abbreviation'))
const StudyCondition = lazy(() => import('@/modules/stability-maintenance-module/StudyCondition'))
const PackageManufactureSite = lazy(
  () => import('@/modules/stability-maintenance-module/PackageManuFactureSite')
)
const AnnualLogReport = lazy(() => import('@/modules/stability-maintenance-module/AnnualLogReport'))
const FinalProduct = lazy(() => import('@/modules/stability-maintenance-module/FinalProduct'))
const EditProduct = lazy(() => import('@/modules/stability-maintenance-module/EditProduct'))
const ViewProduct = lazy(() => import('@/modules/stability-maintenance-module/ViewProduct'))
const TestLibrary = lazy(() => import('@/modules/stability-maintenance-module/TestLibrary'))
const EditLogReportStabMM = lazy(
  () => import('@/modules/stability-maintenance-module/EditLogReport')
)

const Level1Approval = lazy(() => import('@/modules/stability-maintenance-module/Level1Approval'))

export const stabilityMaintenanceRoutes = {
  ...createRoute('/stabilityMaintenanceModules', <StabilityMaintenanceModules />),
  children: [
    createRoute('analyst', <Analyst />),
    createRoute('abbreviation', <Abbreviation />),
    createRoute('packagingSize', <PackagingManager name="PACKAGE SIZE" />),
    createRoute('container', <PackagingManager name="CONTAINER" />),
    createRoute('containerResin', <PackagingManager name="CONTAINER RESIN" />),
    createRoute('containerManufacturer', <PackagingManager name="CONTAINER MANUFACTURER" />),
    createRoute('closure', <PackagingManager name="CLOSURE" />),
    createRoute('closureManufacturer', <PackagingManager name="CLOSURE MANUFACTURER" />),
    createRoute('innerSeal', <PackagingManager name="INNERSEAL" />),
    createRoute('liner', <PackagingManager name="LINER" />),
    createRoute('linerManufacturer', <PackagingManager name="LINER MANUFACTURER" />),
    createRoute('filler', <PackagingManager name="FILLER" />),
    createRoute('fillerManufacturer', <PackagingManager name="FILLER MANUFACTURER" />),
    createRoute('desiccant', <PackagingManager name="DESICCANT" />),
    createRoute('desiccantManufacturer', <PackagingManager name="DESICCANT MANUFACTURER" />),
    createRoute('blisters', <PackagingManager name="BLISTERS" />),
    createRoute('liddingFoil', <PackagingManager name="LIDDING FOIL" />),
    createRoute('formingFoil', <PackagingManager name="FORMING FOIL" />),
    createRoute('other', <PackagingManager name="OTHER" />),
    createRoute('otherManufacturer', <PackagingManager name="OTHER MANUFACTURER" />),
    createRoute('quickList', <PackagingManager name="QUICKLIST" />),
    createRoute('reasonForStudy', <PackagingManager name="REASON FOR STUDY" />),
    createRoute('site', <PackageManufactureSite />),
    createRoute('storageLocation', <PackagingManager name="STORAGE LOCATION" />),
    createRoute('studyCondition', <StudyCondition />),
    createRoute('userDefinedFields', <PackagingManager name="USER DEFINED FIELDS" />),
    createRoute('annualLogReport', <AnnualLogReport />),
    createRoute('labNumber', <PackagingManager name="LAB NUMBER" />),
    createRoute('measurement', <PackagingManager name="MEASUREMENT" />),
    createRoute('finalProduct', <FinalProduct />),
    createRoute('level1Approval', <Level1Approval />),
    createRoute('editProduct', <EditProduct />),
    createRoute('viewProduct', <ViewProduct />),
    createRoute('testLibrary', <TestLibrary />),
    createRoute('editLogReport', <EditLogReportStabMM />)
  ]
}
